<div #wrapper class="d-inline-block position-relative">
  <!-- Whatever you place between <app-reaction-picker>...</app-reaction-picker>
  becomes the trigger, wrapped in this span -->
  <span #trigger (click)="togglePanel()">
    <ng-content></ng-content>
  </span>

  @if (isOpen) {
    <div
      #panel
      class="reaction-panel shadow-sm text-white d-inline-flex align-items-center"
      >
      @for (reaction of reactions; track reaction) {
        <button
          type="button"
          class="btn btn-link btn-sm text-white text-decoration-none reaction-btn p-1"
          (click)="selectReaction(reaction)"
          [attr.aria-label]="reaction.desc"
          >
          <span class="fs-4">{{ getEmojiFromCode(reaction.code) }}</span>
        </button>
      }
      @if (enableCustomEmoji) {
        <button
          type="button"
          class="btn btn-link btn-sm reaction-plus-btn p-1"
          (click)="openEmojiPopup($event)"
          aria-label="More reactions"
          >
          <span class="plus-circle">＋</span>
        </button>
      }
    </div>
  }
</div>
